module.exports = __webpack_public_path__ + "static/media/cirkusen.f40dd25a.png";